import { render, staticRenderFns } from "./chateau-gruaud-larose.vue?vue&type=template&id=3608fd01&scoped=true"
import script from "./chateau-gruaud-larose.vue?vue&type=script&lang=js"
export * from "./chateau-gruaud-larose.vue?vue&type=script&lang=js"
import style0 from "./chateau-gruaud-larose.vue?vue&type=style&index=0&id=3608fd01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608fd01",
  null
  
)

export default component.exports